"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SamplingEventType = void 0;
var SamplingEventType;
(function (SamplingEventType) {
    SamplingEventType[SamplingEventType["Standard"] = 0] = "Standard";
    SamplingEventType[SamplingEventType["Remediation"] = 1] = "Remediation";
    SamplingEventType[SamplingEventType["Winterized"] = 2] = "Winterized";
    SamplingEventType[SamplingEventType["Winterized - Field"] = 3] = "Winterized - Field";
})(SamplingEventType = exports.SamplingEventType || (exports.SamplingEventType = {}));
//# sourceMappingURL=SamplingEventType.js.map